import { render, staticRenderFns } from "./InfoBookingQuestionAnswer.vue?vue&type=template&id=0a98837b"
import script from "./InfoBookingQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./InfoBookingQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports